import { render, staticRenderFns } from "./ClassPayments.vue?vue&type=template&id=72ea0999&"
import script from "./ClassPayments.vue?vue&type=script&lang=js&"
export * from "./ClassPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports